import React from 'react';
import { FadeIn } from './FadeIn';
import { Quote } from 'lucide-react';
export function Proof() {
  return <section className="py-24 bg-terracotta text-white relative overflow-hidden" data-id="element-81">
      {/* Decorative background element */}
      <div className="absolute -top-24 -right-24 w-96 h-96 bg-white/10 rounded-full blur-3xl pointer-events-none" data-id="element-82"></div>
      <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-black/10 rounded-full blur-3xl pointer-events-none" data-id="element-83"></div>

      <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-84">
        <FadeIn data-id="element-85">
          <div className="text-center" data-id="element-86">
            <Quote className="mx-auto text-white/30 mb-8" size={48} data-id="element-87" />

            <p className="text-2xl md:text-3xl font-serif leading-relaxed mb-8" data-id="element-88">
              En solo 7 días, tu relación con las 6:00 PM cambiará. Pasarás de
              la parálisis visual a un flujo donde la cena se hace "sola" y las
              superficies de tu casa permanecen despejadas.
            </p>

            <p className="text-lg text-white/90 font-light max-w-2xl mx-auto" data-id="element-89">
              No es magia, es neurociencia aplicada a las tareas del hogar para
              reducir la fricción mental.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}